import React from 'react'
import styled from 'styled-components'
import { Colors } from '@curvo/common-ui'

const LockWrapper = styled.svg`
  margin-right: 10px;
`

export const Lock = () => (
  <LockWrapper
    width="12px"
    height="16px"
    viewBox="0 0 18 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Glyphs" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Atoms-/-Glyphs-/-Lock" transform="translate(-3.000000, 0.000000)" fill="#FFFFFF" fillRule="nonzero">
        <path d="M12,0 C8.699219,0 6,2.699219 6,6 L6,11 L5,11 C3.8954305,11 3,11.8954305 3,13 L3,22 C3,23.1045695 3.8954305,24 5,24 L19,24 C20.1045695,24 21,23.1045695 21,22 L21,13 C21,11.8954305 20.1045695,11 19,11 L18,11 L18,6 C18,2.699219 15.300781,0 12,0 Z M12,2 C14.21875,2 16,3.78125 16,6 L16,11 L8,11 L8,6 C8,3.78125 9.78125,2 12,2 Z" />
      </g>
    </g>
  </LockWrapper>
)

export const PlanIcon = () => (
  <svg
    width="63px"
    height="53px"
    viewBox="0 0 63 53"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <defs>
      <linearGradient x1="43.1430459%" y1="14.5315271%" x2="97.9173155%" y2="81.460417%" id="linearGradient-1">
        <stop stopColor="#1750DA" offset="0%" />
        <stop stopColor="#103EAF" offset="100%" />
      </linearGradient>
      <path
        d="M2,0 L31.5,0 C48.8969696,-3.19577147e-15 63,14.1030304 63,31.5 L63,61 C63,62.1045695 62.1045695,63 61,63 L31.5,63 C14.1030304,63 2.13051432e-15,48.8969696 0,31.5 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z"
        id="path-2"
      />
      <linearGradient x1="97.0128881%" y1="80.0354675%" x2="0%" y2="0%" id="linearGradient-4">
        <stop stopColor="#56BBFF" stopOpacity="0" offset="0%" />
        <stop stopColor="#44FBFF" offset="100%" />
      </linearGradient>
    </defs>
    <g id="Account" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-293.000000, -907.000000)" id="Plans">
        <g transform="translate(229.000000, 785.000000)">
          <g transform="translate(48.000000, 87.000000)" id="Group">
            <g transform="translate(16.000000, 35.000000)">
              <mask id="mask-3" fill="white">
                <use xlinkHref="#path-2" />
              </mask>
              <use id="Rectangle" fill="url(#linearGradient-1)" xlinkHref="#path-2" />
              <path
                d="M-5.56,-7.56 L27.876,-7.56 C38.6455526,-7.56 47.376,1.17044738 47.376,11.94 L47.376,55.44 L11.94,55.44 C1.17044738,55.44 -7.56,46.7095526 -7.56,35.94 L-7.56,-5.56 C-7.56,-6.6645695 -6.6645695,-7.56 -5.56,-7.56 Z"
                id="Rectangle"
                fill="url(#linearGradient-4)"
                mask="url(#mask-3)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const CardNumberPlaceholder = () => (
  <svg
    width="180px"
    height="6px"
    viewBox="0 0 180 6"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Account" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Billings" transform="translate(-262.000000, -517.000000)" fill="#899DA6">
        <g id="Card" transform="translate(230.000000, 375.000000)">
          <path
            d="M35,142 C36.6568542,142 38,143.343146 38,145 C38,146.656854 36.6568542,148 35,148 C33.3431458,148 32,146.656854 32,145 C32,143.343146 33.3431458,142 35,142 Z M44,142 C45.6568542,142 47,143.343146 47,145 C47,146.656854 45.6568542,148 44,148 C42.3431458,148 41,146.656854 41,145 C41,143.343146 42.3431458,142 44,142 Z M53,142 C54.6568542,142 56,143.343146 56,145 C56,146.656854 54.6568542,148 53,148 C51.3431458,148 50,146.656854 50,145 C50,143.343146 51.3431458,142 53,142 Z M62,142 C63.6568542,142 65,143.343146 65,145 C65,146.656854 63.6568542,148 62,148 C60.3431458,148 59,146.656854 59,145 C59,143.343146 60.3431458,142 62,142 Z M84,142 C85.6568542,142 87,143.343146 87,145 C87,146.656854 85.6568542,148 84,148 C82.3431458,148 81,146.656854 81,145 C81,143.343146 82.3431458,142 84,142 Z M93,142 C94.6568542,142 96,143.343146 96,145 C96,146.656854 94.6568542,148 93,148 C91.3431458,148 90,146.656854 90,145 C90,143.343146 91.3431458,142 93,142 Z M102,142 C103.656854,142 105,143.343146 105,145 C105,146.656854 103.656854,148 102,148 C100.343146,148 99,146.656854 99,145 C99,143.343146 100.343146,142 102,142 Z M111,142 C112.656854,142 114,143.343146 114,145 C114,146.656854 112.656854,148 111,148 C109.343146,148 108,146.656854 108,145 C108,143.343146 109.343146,142 111,142 Z M133,142 C134.656854,142 136,143.343146 136,145 C136,146.656854 134.656854,148 133,148 C131.343146,148 130,146.656854 130,145 C130,143.343146 131.343146,142 133,142 Z M142,142 C143.656854,142 145,143.343146 145,145 C145,146.656854 143.656854,148 142,148 C140.343146,148 139,146.656854 139,145 C139,143.343146 140.343146,142 142,142 Z M151,142 C152.656854,142 154,143.343146 154,145 C154,146.656854 152.656854,148 151,148 C149.343146,148 148,146.656854 148,145 C148,143.343146 149.343146,142 151,142 Z M160,142 C161.656854,142 163,143.343146 163,145 C163,146.656854 161.656854,148 160,148 C158.343146,148 157,146.656854 157,145 C157,143.343146 158.343146,142 160,142 Z M182,142 C183.656854,142 185,143.343146 185,145 C185,146.656854 183.656854,148 182,148 C180.343146,148 179,146.656854 179,145 C179,143.343146 180.343146,142 182,142 Z M191,142 C192.656854,142 194,143.343146 194,145 C194,146.656854 192.656854,148 191,148 C189.343146,148 188,146.656854 188,145 C188,143.343146 189.343146,142 191,142 Z M200,142 C201.656854,142 203,143.343146 203,145 C203,146.656854 201.656854,148 200,148 C198.343146,148 197,146.656854 197,145 C197,143.343146 198.343146,142 200,142 Z M209,142 C210.656854,142 212,143.343146 212,145 C212,146.656854 210.656854,148 209,148 C207.343146,148 206,146.656854 206,145 C206,143.343146 207.343146,142 209,142 Z"
            id="Combined-Shape"
          />
        </g>
      </g>
    </g>
  </svg>
)

export const VisaIcon = () => (
  <svg
    width="82px"
    height="48px"
    viewBox="0 0 82 48"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Account" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Billings" transform="translate(-262.000000, -437.000000)">
        <g id="Card" transform="translate(230.000000, 375.000000)">
          <g id="Visa-Card" transform="translate(32.000000, 62.000000)">
            <rect id="Rectangle" fill="#191F71" x="0" y="0" width="82" height="48" rx="3" />
            <path
              d="M38.6646543,30.5714058 L35.2843303,30.5714058 L37.3969894,17.4216374 L40.7776607,17.4216374 L38.6646543,30.5714058 Z M32.4405932,17.4216374 L29.2179458,26.4661483 L28.8366045,24.5185165 L28.8369518,24.51922 L27.6995264,18.6056231 C27.6995264,18.6056231 27.5619934,17.4216374 26.0960171,17.4216374 L20.7683514,17.4216374 L20.7058364,17.6442943 C20.7058364,17.6442943 22.3350463,17.9876009 24.2417532,19.1473159 L27.1785682,30.5717575 L30.7005928,30.5717575 L36.0786179,17.4216374 L32.4405932,17.4216374 Z M59.0285625,30.5714058 L62.1324314,30.5714058 L59.4262273,17.4212857 L56.7089094,17.4212857 C55.4540948,17.4212857 55.148466,18.4012572 55.148466,18.4012572 L50.1069799,30.5714058 L53.6307411,30.5714058 L54.3354239,28.618146 L58.6326343,28.618146 L59.0285625,30.5714058 Z M55.3089211,25.9198828 L57.0850412,20.9989203 L58.084239,25.9198828 L55.3089211,25.9198828 Z M50.3712794,20.583857 L50.8536867,17.7600195 C50.8536867,17.7600195 49.3651355,17.1866694 47.8133747,17.1866694 C46.1358893,17.1866694 42.1522957,17.9292106 42.1522957,21.5399096 C42.1522957,24.9370973 46.8277218,24.9793071 46.8277218,26.7637276 C46.8277218,28.548148 42.6340084,28.2284086 41.2499961,27.1031649 L40.7474451,30.0557424 C40.7474451,30.0557424 42.2568347,30.7982836 44.5629429,30.7982836 C46.8697458,30.7982836 50.3497465,29.5886203 50.3497465,26.2962537 C50.3497465,22.8772577 45.6322964,22.5589252 45.6322964,21.0724358 C45.6326437,19.5855946 48.9247522,19.7765941 50.3712794,20.583857 Z"
              id="Shape"
              fill="#FFFFFF"
              fillRule="nonzero"
            />
            <path
              d="M28.8369518,24.5188682 L27.6995264,18.6052713 C27.6995264,18.6052713 27.5619934,17.4212857 26.0960171,17.4212857 L20.7683514,17.4212857 L20.7058364,17.6439425 C20.7058364,17.6439425 23.2665195,18.1814143 25.7226637,20.1951749 C28.0711432,22.119943 28.8369518,24.5188682 28.8369518,24.5188682 Z"
              id="Path"
              fill="#F7B600"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

const SearchIconWrapper = styled.svg`
  margin-right: 0.5rem;
`

export const SearchIcon = () => (
  <SearchIconWrapper width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-1082 -568)" stroke="#FFF" strokeWidth="2">
        <g transform="translate(1040 541)">
          <g transform="translate(43 28)">
            <circle cx="7" cy="7" r="7" />
            <path d="M12.5,12.5 L17.9447222,17.9447222" />
          </g>
        </g>
      </g>
    </g>
  </SearchIconWrapper>
)

export const ArrowIcon: React.FC<{ goUp?: boolean }> = ({ goUp }) => (
  <svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-3 -3)" fill={goUp ? '#00D18B' : '#EC2434'}>
        {goUp ? (
          <path
            d="M8.5,12.2013677 L11.4072548,9.10029596 C11.5961199,8.89883982 11.9125378,8.88863279 12.1139939,9.07749792 C12.3154501,9.26636305 12.3256571,9.58278095 12.136792,9.78423709 L8.37153027,13.8005162 C8.17399348,14.0112222 7.83952987,14.0112222 7.64199307,13.8005162 L3.86523302,9.77197219 C3.6763679,9.57051606 3.68657493,9.25409815 3.88803106,9.06523302 C4.0894872,8.8763679 4.4059051,8.88657493 4.59477023,9.08803106 L7.5,12.1869428 L7.5,2.5 C7.5,2.22385763 7.72385763,2 8,2 C8.27614237,2 8.5,2.22385763 8.5,2.5 L8.5,12.2013677 Z"
            transform="scale(1 -1) rotate(-45 -11.263 0)"
          />
        ) : (
          <path
            d="M8.5,12.2013677 L11.4072548,9.10029596 C11.5961199,8.89883982 11.9125378,8.88863279 12.1139939,9.07749792 C12.3154501,9.26636305 12.3256571,9.58278095 12.136792,9.78423709 L8.37153027,13.8005162 C8.17399348,14.0112222 7.83952987,14.0112222 7.64199307,13.8005162 L3.86523302,9.77197219 C3.6763679,9.57051606 3.68657493,9.25409815 3.88803106,9.06523302 C4.0894872,8.8763679 4.4059051,8.88657493 4.59477023,9.08803106 L7.5,12.1869428 L7.5,2.5 C7.5,2.22385763 7.72385763,2 8,2 C8.27614237,2 8.5,2.22385763 8.5,2.5 L8.5,12.2013677 Z"
            transform="rotate(45 8.001 7.98)"
          />
        )}
      </g>
    </g>
  </svg>
)

ArrowIcon.defaultProps = { goUp: false }

const ToggleIconWrapper = styled.svg`
  margin-left: 0.5rem;
`

export const ToggleIcon = () => (
  <ToggleIconWrapper width="10" height="5" viewBox="0 0 10 5" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
      <g transform="translate(-3 -6)" stroke={Colors.Primary}>
        <polyline id="Line" points="12.5 6 8 10.8 3.5 6" />
      </g>
    </g>
  </ToggleIconWrapper>
)

export const CheckedIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 426.67 426.67" width="16px" height="16px">
    <path
      d="M153.504,366.839c-8.657,0-17.323-3.302-23.927-9.911L9.914,237.265	c-13.218-13.218-13.218-34.645,0-47.863c13.218-13.218,34.645-13.218,47.863,0l95.727,95.727l215.39-215.386	c13.218-13.214,34.65-13.218,47.859,0c13.222,13.218,13.222,34.65,0,47.863L177.436,356.928	C170.827,363.533,162.165,366.839,153.504,366.839z"
      fill={Colors.Primary}
    />
  </svg>
)
